<template>
    <el-button type="primary" size="small" circle>
        <ComTooltip content="Tuo">
            <el-icon>
                <Download></Download>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { Download } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Download,
        ComTooltip,
    },
})
</script>
